import BaseLayout from "./BaseLayout";
import { useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";

const MainLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/") {
      navigate("/dashboard");
    }
  }, [location.pathname, navigate]);

  return <BaseLayout isAdmin={false} />;
};

export default MainLayout;
